import { UserClient } from '../types'
import {GetUserResponseData} from '../types/UserClient'

export const getUser = (base: UserClient) => () =>
  base.requester.get<GetUserResponseData>('', { withCredentials: true })
